import "@fontsource/dm-sans/400.css";
import "@fontsource/dm-sans/500.css";
import "@fontsource/dm-sans/700.css";
import { createTheme, CssBaseline, ThemeProvider } from "@mui/material";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import Footer from "./components/Footer/Footer";
import Home from "./components/Home/Home";

const theme = createTheme({
  palette: {
    primary: {
      main: "#1F3E76",
    },
    secondary: {
      main: "#3FDBB1",
    },
    info: {
      main: "#fff",
    },
  },
});

function App() {
  return (
    <div className="App">
      <CssBaseline>
        <ThemeProvider theme={theme}>
          <Router>
            {/* routes  */}
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/home" element={<Home />} />
            </Routes>
            {/* footer  */}
            <Footer />
          </Router>
        </ThemeProvider>
      </CssBaseline>
    </div>
  );
}

export default App;
